module.exports = __webpack_public_path__ + "img/slide5.dd346617.png";